import { useCallback } from 'react'
import { disconnectProvider } from '../../store/app/hooks'
import { useWeb3React } from '@web3-react/core'

export function useDisconnect() {
  const { connector } = useWeb3React()

  return useCallback(
    async function disconnect() {
      disconnectProvider()

      if (connector.deactivate) {
        connector.deactivate()
      }
      connector.resetState()
    },
    [connector]
  )
}
